import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Fadein } from 'src/app/animations';
import {
  IcalOnboardingService,
  OnboardingState,
} from '../ical-onboarding.service';
import { IcalSubscribeModalComponent } from '../ical-subscribe-modal/ical-subscribe-modal.component';

@Component({
  selector: 'app-ical-onboarding-banner',
  templateUrl: './ical-onboarding-banner.component.html',
  styleUrls: ['./ical-onboarding-banner.component.scss'],
  animations: [Fadein],
  standalone: false,
})
export class IcalOnboardingBannerComponent implements OnInit {
  visible = false;
  state: OnboardingState | null = null;

  constructor(
    private onboardingService: IcalOnboardingService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private translate: TranslateService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadState();
  }

  private loadState(): void {
    this.onboardingService.getState().subscribe({
      next: (state) => {
        this.state = state;
        this.visible = this.onboardingService.shouldShowBanner(state);
        this.ref.markForCheck();
      },
      error: () => {
        // Si falla el GET, no mostrar banner (no es bloqueante).
        this.visible = false;
        this.ref.markForCheck();
      },
    });
  }

  onSubscribe(): void {
    const ref = this.dialog.open(IcalSubscribeModalComponent, {
      data: { icalUrl: this.state?.icalUrl ?? null },
      autoFocus: false,
      panelClass: 'bv-ical-modal-panel',
    });

    ref.afterClosed().subscribe((result) => {
      // Si el user generó la URL desde el modal, actualizar el state local.
      if (result?.icalUrl && this.state) {
        this.state = { ...this.state, icalUrl: result.icalUrl };
      }
      // Nota: el banner sigue visible hasta que G.Cal/Outlook efectivamente
      // hagan un GET al feed (eso es lo que marca subscribed=true en backend).
      // Esto es deliberado — el user puede que haya copiado la URL pero
      // todavía no la haya suscripto en su calendario.
      this.ref.markForCheck();
    });
  }

  onSnooze(): void {
    this.onboardingService.snooze().subscribe({
      next: (ok) => {
        if (ok) {
          this.visible = false;
          this.ref.markForCheck();
        } else {
          this.showError();
        }
      },
      error: () => this.showError(),
    });
  }

  onDismiss(): void {
    this.onboardingService.dismiss().subscribe({
      next: (ok) => {
        if (ok) {
          this.visible = false;
          this.ref.markForCheck();
        } else {
          this.showError();
        }
      },
      error: () => this.showError(),
    });
  }

  private showError(): void {
    this.snackbar.open(
      this.translate.instant('ALERTS.ONBOARDING.ERROR_GENERIC'),
      'Cerrar',
      { duration: 4000 }
    );
  }
}
